import { pipe } from "fp-ts/function";
import * as A from "fp-ts/Array";
export function pureIf(F) {
    return x => y => x ? F.of(y()) : F.zero();
}
export function altAllBy(F) {
    return fs => x => pipe(fs, A.reduce(F.zero(), (m, f) => F.alt(m, () => f(x))));
}
